module.exports = __webpack_public_path__ + "static/media/slide3.c22419fa.jpg";